export default __webpack_public_path__ + "static/media/sconto-digitalsuperhero.19f57412.svg";